import api from "./api";

export const listGlobalApiPresets = async (query = {}) => {
  const { data } = await api.get("/admin/v1/api-presets", { params: query });
  return data;
};

export const showGlobalApiPreset = async (id) => {
  const { data } = await api.get(`/admin/v1/api-presets/${id}`);
  return data;
};

export const createGlobalApiPreset = async (payload) => {
  const { data } = await api.post("/admin/v1/api-presets", payload);
  return data;
};

export const updateGlobalApiPreset = async (id, payload) => {
  const { data } = await api.patch(`/admin/v1/api-presets/${id}`, payload);
  return data;
};

export const deleteGlobalApiPreset = async (id) => {
  const { data } = await api.delete(`/admin/v1/api-presets/${id}`);
  return data;
};
